module.exports = __webpack_public_path__ + "img/chauffeur.27ac3c8a.svg";